<template>
    <div class="md-card">
        <h6 class="md-card-header" style="text-align: left">
            {{ $t('shift.main.planning') }}
            <i class="fas fa-times" style="float: right"
               @click="closeShiftDesignModal"></i>
        </h6>
        <div class="md-card-body">
            <datatablesimple :state="planningTableState"></datatablesimple>
        </div>
    </div>
</template>

<script>
    export default {
        name: "shiftDesignModal",
        props: {
            planningState: Array,
            showShiftDesignDetails: Boolean,
            selectedShiftDesign: Object,
        },
        computed: {
            planningTableState() {
                let view = this;

                let data = view.planningState;
                if (data === null) {
                    return;
                }

                let state = {};
                state.headerMap = [];

                let columns = {};
                columns.id = "Id";
                columns.creationDate = this.$t('roster.main.planDate');
                columns.from = this.$t('global.general.from');
                columns.to = this.$t('global.general.to');
                columns.status = this.$t('global.general.status');
                columns.actions = " ";

                state = view.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

                view.$helpers.buildHeaderMapLabel(state.headerMap, 'id');
                state.headerMap.id.hidden = true;
                view.$helpers.buildHeaderMapLabel(state.headerMap, 'creationDate');
                view.$helpers.buildHeaderMapLabel(state.headerMap, 'from');
                view.$helpers.buildHeaderMapLabel(state.headerMap, 'to');
                view.$helpers.buildHeaderMapLabel(state.headerMap, 'status');

                state.headerMap.actions.stylesEntry = {'justify-content': 'left'};
                let selected = view.selectedShiftDesign !== null ? view.selectedShiftDesign.id : null;
                state.headerMap.actions.componentStateBuilders = [
                    (data) => {
                        return {
                            componentType: 'buttonc',
                            tooltip: () => {
                                return this.$t('shift.main.planningDetails')
                            },
                            type: 'button icon-overlay square',
                            icon:  view.showShiftDesignDetails && selected === data.id ? "fas fa-eye-slash" : "fas fa-eye",
                            styleButton: {margin: '0 2px 0 2px'},
                            hideInput: false,
                            customEvents: {
                                click: () => {
                                    view.openShiftDesignDetails(data.id);
                                }
                            }
                        }
                    },
                    (data) => {
                        return {
                            componentType: 'buttonc',
                            tooltip: () => {
                                return this.$t('shift.main.deleteShiftDesign')
                            },
                            type: 'button icon-overlay square',
                            icon:  "fas fa-trash",
                            styleButton: {margin: '0 2px 0 2px'},
                            hideInput: data.state < 2,
                            customEvents: {
                                click: () => {
                                    view.deleteShiftDesign(data.id);
                                }
                            }
                        }
                    },
                ];

                let entries = Object.entries(state.headerMap);

                let nameColumns = ['actions'];
                let nameColumnWidth = 5;
                let mainColumns = ['creationDate','from','to','status'];
                let mainColumnWidth = 20;

                for (let x in entries) {
                    if (nameColumns.includes(entries[x][0])) {
                        entries[x][1].width = nameColumnWidth + '%';
                    } else if (mainColumns.includes(entries[x][0])) {
                        entries[x][1].width = mainColumnWidth + '%';
                    }

                    entries[x][1].key = entries[x][0];

                }

                state.headerStyles = {fontSize: '12px', position: "sticky", top: 0, zIndex: 10};
                state.heightSubRow = 'fit-content';
                state.rowStyles = {background: '#6d8d23'};
                state.rowStylesCollapsed = {fontSize: '10px'};
                state.sumRowStyles = {background: 'var(--sub-menu)'}
                state.alwaysUnfold = false;
                return state;
            }
        },
        methods: {
            closeShiftDesignModal() {
                this.$emit("close-shift-design-modal");
            },
            openShiftDesignDetails(shiftDesignId) {
                this.$emit("open-shift-design-details", shiftDesignId);
            },
            deleteShiftDesign(shiftDesignId) {
                this.$emit("delete-shift-design", shiftDesignId);
            }
        }
    }

</script>

<style scoped>
.md-card {
    position: absolute;
    z-index: 100;
    width: calc(50% - 18px);
    top: 55px;
    left: 18px;
    bottom: auto;
    right: auto;
}

.md-card-body {
    max-height: calc(100vh - var(--header-height) - 140px);
    scrollbar-width: none;
}
</style>
